import { IconProps } from './fr-fi-icons';

const TokenIcon: React.FC<IconProps> = ({
  color = 'var(--text-action-high-blue-france)',
  size = 32,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 56 56"
  >
    <rect fill="#fff" width="56" height="56" />
    <path
      fill="#cee0f2"
      d="M10.6,32.2V15.8a10,10,0,0,1,10-10H14.5a10,10,0,0,0-10,10V32.2a10,10,0,0,0,10,10h6.07a10,10,0,0,1-10-10Z"
    />
    <path
      fill={color}
      d="M41.6,44.2H14.4a12,12,0,0,1-12-12V15.8a12,12,0,0,1,12-12H41.6a12,12,0,0,1,12,12V32.2A12,12,0,0,1,41.6,44.2ZM14.4,7.8a8,8,0,0,0-8,8V32.2a8,8,0,0,0,8,8H41.6a8,8,0,0,0,8-8V15.8a8,8,0,0,0-8-8ZM39.6,50.2a2,2,0,0,0-2-2H18.4a2,2,0,1,0,0,4H37.6A2,2,0,0,0,39.6,50.2Z"
    />
    <path
      fill="#0063cb"
      d="M37.63,27.69l-1.33-.8a8.59,8.59,0,0,0,0-5.18l1.33-.8a2,2,0,0,0-2.06-3.43l-1.36.82a8.44,8.44,0,0,0-4-2.26V14.3a2,2,0,0,0-4,0V16a8.49,8.49,0,0,0-4.09,2.34l-1.48-.9a2,2,0,0,0-2.06,3.43l1.5.91a8.5,8.5,0,0,0,0,5l-1.5.9a2,2,0,0,0,1,3.72,1.94,1.94,0,0,0,1-.29l1.48-.89a8.49,8.49,0,0,0,4.09,2.34V34.3a2,2,0,0,0,4,0V32.56a8.44,8.44,0,0,0,4-2.26l1.36.82a2,2,0,0,0,2.75-.69,2,2,0,0,0-.69-2.74ZM28.2,28.8a4.5,4.5,0,1,1,4.5-4.5A4.51,4.51,0,0,1,28.2,28.8Z"
    />
  </svg>
);

export default TokenIcon;
